import { Avatar } from "components/core";
import { FC } from "react";
import { Insurer_insurer } from "_graphql/queries/__generated__/Insurer";
import _ from "lodash";

type Props = {
    insurer: Insurer_insurer | null | undefined;
};

const InsurerView: FC<Props> = ({ insurer }) => {
    const brokerageBreakdown: Record<string, number> = JSON.parse(
        insurer?.insurer_overview?.total_brokerage_amt || "{}",
    );
    const facPremiumBreakdown: Record<string, number> = JSON.parse(
        insurer?.insurer_overview?.total_fac_premium || "{}",
    );
    const wthBreakdown: Record<string, number> = JSON.parse(
        insurer?.insurer_overview?.total_withholding_tax || "{}",
    );

    const total_outstanding_fac_premium: Record<string, number> = JSON.parse(
        insurer?.insurer_overview?.total_outstanding_fac_premium || "{}",
    );
    const total_fac_recoveries_due: Record<string, number> = JSON.parse(
        insurer?.insurer_overview?.total_fac_recoveries_due || "{}",
    );
    const total_fac_nic_levy: Record<string, number> = JSON.parse(
        insurer?.insurer_overview?.total_fac_nic_levy || "{}",
    );

    // Treaty Overview
    const total_treaty_recoveries_due: Record<string, number> = JSON.parse(
        insurer?.insurer_overview?.treaties_overview
            ?.total_treaty_recoveries_due || "{}",
    );

    return (
        <div className="space-y-6 divide-y divide-gray-200">
            <div>
                <span className="text-xs  text-secondary">
                    Company Information
                </span>
                <div className="grid grid-cols-3 gap-6 mt-2">
                    <div className="row-span-2 flex flex-col space-y-3 items-center justify-center">
                        <Avatar
                            alt={insurer?.insurer_abbrv || "N A"}
                            size="xl"
                        />
                    </div>
                    <div className="col-span-3">
                        <span className="block text-sm  text-secondary">
                            Company Name
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {insurer?.insurer_company_name || "N/A"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    Contact Information
                </span>
                <div className="grid grid-cols-3 gap-6 mt-2">
                    <div className="col-span-2">
                        <span className="block text-sm  text-secondary">
                            Email Address
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {insurer?.insurer_company_email || "N/A"}
                        </div>
                    </div>

                    <div>
                        <span className="block text-sm  text-secondary">
                            Website
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {insurer?.insurer_company_website || "N/A"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    Address Information
                </span>
                <div className="grid grid-cols-3 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            County
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {insurer?.insurer_address?.country || "N/A"}
                        </div>
                    </div>

                    <div>
                        <span className="block text-sm  text-secondary">
                            Region
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {insurer?.insurer_address?.region || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Sub-urb
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {insurer?.insurer_address?.suburb || "N/A"}
                        </div>
                    </div>

                    <div>
                        <span className="block col-span-3 text-sm  text-gray-700">
                            Street
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {insurer?.insurer_address?.street || "N/A"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">Offers OverView</span>
                <div className="grid grid-cols-3 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            Total Offers
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {_.sum([
                                insurer?.insurer_overview?.total_closed,
                                insurer?.insurer_overview?.total_pending,
                            ]) || "0"}
                        </div>
                    </div>

                    <div>
                        <span className="block text-sm  text-secondary">
                            Total Pending Offers
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {insurer?.insurer_overview?.total_pending || "0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Total Closed Offers
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {insurer?.insurer_overview?.total_closed || "0"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    Brokerage OverView
                </span>
                <div className="grid grid-cols-4 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            USD
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {brokerageBreakdown?.total_dollar || "0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GBP
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {brokerageBreakdown?.total_pounds || "0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GHS
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {brokerageBreakdown?.total_cedis || "0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            EUR
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {brokerageBreakdown?.total_euros || "0"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    Facultative Premium OverView
                </span>
                <div className="grid grid-cols-4 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            USD
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {facPremiumBreakdown?.total_dollar || "0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GBP
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {facPremiumBreakdown?.total_pounds || "0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GHS
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {facPremiumBreakdown?.total_cedis || "0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            EUR
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {facPremiumBreakdown?.total_euros || "0"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    Withholding Tax OverView
                </span>
                <div className="grid grid-cols-4 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            USD
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {wthBreakdown?.total_dollar || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GBP
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {wthBreakdown?.total_pounds || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GHS
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {wthBreakdown?.total_cedis || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            EUR
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {wthBreakdown?.total_euros || "0.0"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    NIC Levy Overview
                </span>
                <div className="grid grid-cols-4 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            USD
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_fac_nic_levy?.total_dollar || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GBP
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_fac_nic_levy?.total_pounds || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GHS
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_fac_nic_levy?.total_cedis || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            EUR
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_fac_nic_levy?.total_euros || "0.0"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    Outstanding Facultative Recoveries Due and From
                </span>
                <div className="grid grid-cols-4 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            USD
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_fac_recoveries_due?.total_dollar || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GBP
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_fac_recoveries_due?.total_pounds || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GHS
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_fac_recoveries_due?.total_cedis || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            EUR
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_fac_recoveries_due?.total_euros || "0.0"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    Outstanding Facultative Premiums Due and From
                </span>
                <div className="grid grid-cols-4 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            USD
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_outstanding_fac_premium?.total_dollar ||
                                "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GBP
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_outstanding_fac_premium?.total_pounds ||
                                "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GHS
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_outstanding_fac_premium?.total_cedis ||
                                "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            EUR
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_outstanding_fac_premium?.total_euros ||
                                "0.0"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    Outstanding Treaty Recoveries Due and From
                </span>
                <div className="grid grid-cols-4 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            USD
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_treaty_recoveries_due?.total_dollar || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GBP
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_treaty_recoveries_due?.total_pounds || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            GHS
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_treaty_recoveries_due?.total_cedis || "0.0"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            EUR
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {total_treaty_recoveries_due?.total_euros || "0.0"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InsurerView;
